import { Markup } from "interweave";
import moment from "moment";
import { React, useContext, useEffect, useState } from "react";
import ReactPlayer from "react-player";
import { Link } from "react-router-dom";
import { serverInfo } from "../../App";
import noImage from "../../Assets/Images/settings/no-image.png";
// import Share from "../../Assets/Images/share.png";
import ShareB from "../../Assets/Images/ShareB.png";
import SharePost from "../../Screen/SharePost";

const RightSideCard = ({
  title = null,
  video = null,
  firstName = null,
  lastName = null,
  Msg = null,
  CreateTime = null,
  postData = null,
  post = null,
  fanGrouppost = null,
  activityGreetingVideo = null,
  activityType = null,
  id = null,
}) => {
  const { imageCdnUrl,videoCdnUrl } = useContext(serverInfo);


  return (
    <>
    
      <div className="container PostWidth align-items-center justify-content-center Enroll-Auditions">
        {activityType === "audition" ? (
          <>
            <div className="container PostWidth align-items-center justify-content-center col-11 Enroll-Auditions">
              <div className="card PostCardBg ">
                <div className="ViewPost">
                  <div className=" card  border-0 containerPost px-3 pt-3 new-audition">
                    <ReactPlayer
                      url={videoCdnUrl + post.audition?.video}
                      controls={true}
                      playing={false}
                      volume={1}
                      className="Live-Video-x"
                      style={{ margin: "0 auto" }}
                    />
                    <div className="centeredPost ">
                      <div className="LeftTextPost col-md-8">
                      </div>
                      <div className="LeftTextPost col-md-4">
                        <h6 className="MeetCon-left text-light">
                          {moment(
                            post?.audition?.info?.registration_start_date
                          ).format("LL")}{" "}
                          to{" "}
                          {moment(
                            post?.audition?.info?.registration_end_date
                          ).format("LL")}
                        </h6>
                        <Link
                          to={`/audition/registration/${post.audition?.slug}`}
                          className="link-starPorfile"
                        >
                          <button className="bottom-rightPost text-dark fw-bold  px-3 mb-2">
                            <span className="pTd"> Register Now</span>
                          </button>
                        </Link>
                      </div>
                    </div>
                    <div className="centeredPostV "></div>
                  </div>
                  <div className="row  mx-4 mt-4">
                    <div className="">
                      <center className="d-flex justify-content-center AudiFooter p-3">
                        <span className="carsive_font mt-2 text-warning">
                          With :{" "}
                        </span>

                        {post.audition?.assigned_judges?.map((judge, i) => (
                          <span key={i}>
                            <img
                              src={imageCdnUrl + judge.user?.image}
                              alt=""
                              className="AudiPorS ms-2"
                            />
                          </span>
                        ))}
                      </center>
                    </div>
                  </div>

                  <div className="my-3 mt-4 Enroll-a Enroll-text ">
                    {post.audition?.title}
                  </div>

                  <div className="under-line"></div>
                </div>
              </div>
            </div>
          </>
        ) :null}
      </div>
    </>
  );
};

export default RightSideCard;
